import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import Slots from "./helper/Slots";


class ChooseSlot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data:{},
            trigger: false,
        };

    }

    componentWillMount() {
        const {steps} = this.props;
        const params = {
            services:[steps.serviceId.value],
            location:steps.location.value,
            limit:12,
        };

        API.get('/getSlots',{params}).then((res) => {
            const result = res.data;

            if (result.status == "success") {
                if (result.data.length > 0) {
                    this.setState({
                        data: result.data
                    }, () => {
                        this.setState(
                            {loading: false}
                        );
                    });
                }else{
                    this.setState({
                        data: []
                    }, () => {
                        this.setState(
                            {loading: false}
                        );
                    });
                }
            }
        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    render() {
        const { loading, data} = this.state;
        const { store,triggerNextStep } = this.props;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    <Slots
                        data={data}
                        triggerNextStep={triggerNextStep}
                        settings={store.settings}
                    />
                )}
            </div>
        );
    }
}

ChooseSlot.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

ChooseSlot.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default ChooseSlot;
